export class CookieStorage {
  constructor(private namespace: string, private document: Document) { }

  set(key: string, value: string, expires?: string): void {
    const expiration = expires ? `; expires=${expires}` : '';
    const secure = this.document.location.protocol.indexOf('https') > -1 ? ';Secure' : '';
    this.document.cookie = `${this.namespace}.${key}=${value};path=/${expiration}${secure}`;
  }

  get(key: string): string | null {
    const cookies = this.document.cookie.split(/\s*;\s*/);
    for (const cookie of cookies) {
      const keyVal = cookie.split('=');
      if (keyVal[0] === `${this.namespace}.${key}`) {
        return keyVal[1];
      }
    }
    return null;
  }
}
